import { createContext, useContext } from 'react';

type MyCardsContextType = {
  cardSets: {
    slug: string;
    name: string;
    availableCompetitions?: {
      slug: string;
      displayName: string;
      pictureUrl: string | null;
    }[];
  }[];
};

export const MyCardsContext = createContext<MyCardsContextType>({
  cardSets: [],
});

export const useMyCardsContext = () => {
  return useContext(MyCardsContext);
};
